export default {"src":"/_next/static/media/0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6.684ff353.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};